import { render, staticRenderFns } from "./changeCardNo.vue?vue&type=template&id=242ff1fe&scoped=true"
import script from "./changeCardNo.vue?vue&type=script&lang=js"
export * from "./changeCardNo.vue?vue&type=script&lang=js"
import style0 from "./changeCardNo.vue?vue&type=style&index=0&id=242ff1fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242ff1fe",
  null
  
)

export default component.exports